import React from "react";
import { Flex, Text } from "@theme-ui/components";

const Quote = ({ value, citation, insideGroup }) => {
  return (
    <Flex
      sx={{
        borderLeft: "2px solid",
        borderLeftColor: "lighterGray",
        breakBefore: "avoid",
        pageBreakInside: "avoid",
        borderRadius: "0 30px 30px 0",
        flexDirection: "column",
        justifyContent: "space-between",
        px: [3, 4],
        my: insideGroup ? null : [4, 5],
      }}
    >
      <Text
        as="blockquote"
        variant="subtitle"
        sx={{
          maxWidth: 700,
          fontWeight: "bold",
          m: 0,
          ml: [2, 3],
          lineHeight: 1.3,
          fontSize: insideGroup ? [4, 5] : [4, 5],
          p: {
            position: "relative",
            fontStyle: "normal",
            "&:before": {
              content: '"“"',
              position: "absolute",
              left: "-0.75ch",
            },
            "&:after": {
              content: '"”"',
              position: "relative",
              right: "-0.25ch",
            },
          },
          em: {
            fontStyle: "normal",
          },
        }}
        dangerouslySetInnerHTML={{
          __html: value.replace("”", "").replace("“", ""),
        }}
      />
      <Text
        as="p"
        variant="label"
        dangerouslySetInnerHTML={{ __html: citation }}
        sx={{
          ml: [2, 3],
          mt: [3, 4],
        }}
      />
    </Flex>
  );
};

export default Quote;
